import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { Growl } from 'primereact/growl';
import { AutoComplete } from 'primereact/autocomplete';

import servicioHttp from '../servicios/ServicioHttp';
import ServicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';

export default class Receptor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            receptor: {},
            listaRegimenFiscalReceptor: [],
            usosCfdi: []

        };
    }

    asignarValoresObjeto = (event) => {
        if (event.target.id === "regimenFiscalReceptor") {
            this.buscarUsoCfdiRegimenFiscalRfcReceptor(event.target.value);
        }
        if (event.target.id === "correo") {
            ServicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);

        } else {
            ServicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
        }
    }

    asignarValoresAutoComplete = (event) => {
        let { receptor } = this.state;
        if (typeof event.target.value === 'object') {
            receptor['rfc'] = event.target.value.rfc;
            this.setState({ receptor: event.target.value });
        } else {
            ServicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
        }
    }

    buscarUsoCfdiRegimenFiscalRfcReceptor = (objeto) => {
        let { urlBusquedaUsosCfdi } = this.props;
        let { receptor } = this.state;
        servicioHttp.consumirPostHttp(urlBusquedaUsosCfdi, {
            'rfc': receptor.rfc,
            'regimenFiscal': objeto.id
        }).then(response => {
            this.setState({ usosCfdi: response.data.lista });
        });
    }


    buscarReceptor = () => {
        let { urlBusquedaReceptor, urlRegimenFiscal, erroresFrmDatosFiscales ,regimenFiscales,usosCfdi} = this.props;
        let { receptor } = this.state;
        erroresFrmDatosFiscales = {};
        delete receptor.usoCfdi;
        if (!ServicioAsignacionValoresObjetos.esObjetoVacio(receptor.rfc) && receptor.rfc.length >= 12) {

            if (receptor.rfc === 'XAXX010101000') {


                console.log("XAXX010101000");
      let regimenFiscalObjecto = { "id": "616", "descripcion": "Sin obligaciones fiscales" };
      regimenFiscales = [regimenFiscalObjecto];
      receptor['regimenFiscalReceptor'] = regimenFiscalObjecto;
      let usoCfdiObjecto = { "id": "S01", "descripcion": "Sin efectos fiscales." };
      usosCfdi = [usoCfdiObjecto];
      receptor['usoCfdi'] = usoCfdiObjecto;
      receptor['domicilioFiscalReceptor'] = "00000";
      receptor['rfc']="XAXX010101000";
      console.log(receptor);
      this.setState({ receptor: receptor, listaRegimenFiscalReceptor: regimenFiscales, usosCfdi: usosCfdi });
      this.props.actualizaReceptor(receptor);

            }else{

            servicioHttp.consumirPostHttp(urlBusquedaReceptor, { rfc: receptor.rfc }).then(response => {
                if (!response.error) {
                    receptor = response.data.objeto;
                    if (response.data.error) {
                        erroresFrmDatosFiscales.rfc = response.data.mensaje;
                        receptor = {};
                    } else {
                        servicioHttp.consumirPostHttp(urlRegimenFiscal, { rfc: receptor.rfc }).then(response => {
                            receptor.regimenFiscalReceptor = null;
                            this.setState({ listaRegimenFiscalReceptor: response.data.lista, receptor });
                        });
                    }
                    this.setState({ receptor: receptor });
                    this.props.actualizaReceptor(receptor);
                }
            });
        }

        }
    }

    templateUsoCfdi = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.id} - {option.descripcion}</span>
            </div>
        );
    }

    templateRegimenFiscal = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.id} - {option.descripcion}</span>
            </div>
        );
    }

    buscarReceptorLike = (valor) => {
        setTimeout(() => {

            if (valor.query.length === 0) {

            }else {
                servicioHttp.consumirPostHttp("receptor/buscar_receptor_like_por_rfc.json", { rfc: valor.query.toUpperCase() }).then(response => {
                    if (response.data.error) {
                        this.growl.show({ life: 6000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
                        this.setState({ valorencontrado: response.data.lista });
                    } else {
                        this.growl.show({ life: 1000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
                        this.setState({ valorencontrado: response.data.lista });
                    }
                }).catch((error) => {
                    this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
                });
            }

        }, 250);
    }

    itemTemplateReceptor(receptor) {
        return (
            <div className="p-clearfix">
                {receptor.rfc} - {receptor.nombre}
            </div>
        );
    }

    render() {
        let { erroresFrmDatosFiscales } = this.props;
        let { receptor, listaRegimenFiscalReceptor, usosCfdi } = this.state;
        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid p-fluid">
                    <div className="p-col-12">
                        <h4 style={{ marginTop: '1px', marginBottom: '30px', fontWeight: 'bold' }}>Capturar datos fiscales</h4>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="rfc">* RFC:</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <AutoComplete placeholder="Escribe el RFC de receptor y seleccionalo" name="receptor.rfc" suggestions={this.state.valorencontrado}
                                    completeMethod={this.buscarReceptorLike} value={receptor.rfc || ''} onChange={this.asignarValoresAutoComplete} itemTemplate={this.itemTemplateReceptor} onBlur={this.buscarReceptor} />
                                {erroresFrmDatosFiscales.rfc ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.rfc} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="nombre">* Nombre o Razón Social:</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <InputText id="nombre" name="receptor.nombre" value={receptor.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.nombre ? 'p-error' : ''} placeholder="Nombre o Razón Social" />
                                {erroresFrmDatosFiscales.nombre ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.nombre} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="domicilioFiscalReceptor">* Domicilio Fiscal:</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <InputText id="domicilioFiscalReceptor" name="receptor.domicilioFiscalReceptor" value={receptor.domicilioFiscalReceptor || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.domicilioFiscalReceptor ? 'p-error' : ''} placeholder="Domicilio Fiscal" />
                                {erroresFrmDatosFiscales.domicilioFiscalReceptor ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.domicilioFiscalReceptor} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="regimenFiscalReceptor">* Regimen Fiscal:</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <Dropdown dataKey="id" id="regimenFiscalReceptor" name="receptor.regimenFiscalReceptor" options={listaRegimenFiscalReceptor} value={receptor.regimenFiscalReceptor} onChange={this.asignarValoresObjeto} itemTemplate={this.templateRegimenFiscal} optionLabel="descripcion" className={erroresFrmDatosFiscales.regimenFiscalReceptor ? 'p-error' : ''} />
                                {erroresFrmDatosFiscales.regimenFiscalReceptor ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.regimenFiscalReceptor} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="usoCfdi">* Uso del CFDI:</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <Dropdown dataKey="id" id="usoCfdi" name="receptor.usoCfdi" options={usosCfdi} value={receptor.usoCfdi} onChange={this.asignarValoresObjeto} itemTemplate={this.templateUsoCfdi} optionLabel="descripcion" className={erroresFrmDatosFiscales.usoCfdi ? 'p-error' : ''} />
                                {erroresFrmDatosFiscales.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.usoCfdi} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label htmlFor="correo">* Correo:</label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <InputText id="correo" name="receptor.correo" value={receptor.correo || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.correo ? 'p-error' : ''} placeholder="Correo electrónico" onFocus={this.muestramensajecorreos} />
                                {erroresFrmDatosFiscales.correo ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.correo} /> </div> : null}
                            </div>
                        </div>

                    </div>
                </div>
            </div>)

    }
}